<template>
  <!-- Modal terms -->
  <div
    id="terms-modal"
    aria-hidden="false"
    aria-labelledby="privacyConditionChangedModal"
    class="modal fade"
    role="dialog"
    tabindex="-1"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content vld-parent">
        <loading :active="loading" :is-full-page="false" background-color="#b1b3b1">
          <div>
            <Lottie />
          </div>
        </loading>
        <div class="modal-header">
          <h4 id="privacyConditionChangedModal" class="modal-title" v-html="policyTitle"></h4>
          <button
            id="privacyConditionChangedModalClose"
            aria-hidden="true"
            class="close"
            data-dismiss="modal"
            type="button"
          >
            &times;
          </button>
        </div>
        <div class="modal-body modal-body-min">
          <section class="section">
            <div class="container">
              <div class="row">
                <div class="col-md-12">
                  <div class="article-body">
                    <p v-if="policyDescription" v-html="policyDescription"></p>
                    <p v-if="policyContent" v-html="policyContent"></p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <div class="text-right">
            <button class="btn_1" data-dismiss="modal" type="button">{{ $t('Kapat') }}</button>
          </div>
        </div>
      </div>
      <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
  </div>
  <!-- /.modal -->
</template>
<script>
export default {
  name: 'TermsModal',
  props: {
    countryCode: {
      type: String,
      default: null,
    },
    isConnectCompany: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      policyTitle: null,
      policyDescription: null,
      policyContent: null,
      baseEndpoint: null,
      loading: false,
    };
  },
  watch: {
    countryCode: function (val) {
      if (val) {
        this.getPolicy();
      }
    },
    '$i18n.locale': function (val) {
      if (this.isConnectCompany) {
        this.baseEndpoint = val === 'tr' ? 'policy/connect-tos-tr-' : 'policy/connect-tos-en-';
      } else {
        this.baseEndpoint = val === 'tr' ? 'policy/tos-tr-' : 'policy/tos-en-';
      }
      if (this.countryCode) {
        this.getPolicy();
      }
    },
  },
  created() {
    if (this.isConnectCompany) {
      this.baseEndpoint = this.$i18n.locale === 'tr' ? 'policy/connect-tos-tr-' : 'policy/connect-tos-en-';
    } else {
      this.baseEndpoint = this.$i18n.locale === 'tr' ? 'policy/tos-tr-' : 'policy/tos-en-';
    }
  },
  methods: {
    getPolicy() {
      let endPoint;
      if (this.countryCode.toLowerCase() === 'wt') {
        endPoint = 'policy/terms-of-usage';
      } else {
        endPoint = this.baseEndpoint + this.countryCode.toLowerCase();
      }

      this.loading = true;
      $axios
        .get(endPoint)
        .then((s) => {
          this.policyTitle = s.data.data.title;
          this.policyDescription = s.data.data.description;
          this.policyContent = s.data.data.content;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.modal-dialog {
  max-width: 800px !important;
  padding: 8px !important;
}
</style>
